/* eslint-disable no-param-reassign */
import type { CommonData } from '@/app/common/createCommonData.ts';
import { Analytics } from './Analytics';
import type { ClickParams } from './Analytics/utils';
import { PlatformEnum } from './Analytics/utils/PlatformEnum';
import type { CuriosityParams, RouteType } from './index';
import { getContext, getMarket, getTarget } from './utils';
import type { Localization } from '../common/Localization';

type ClickEvent = {
  clickParams: ClickParams;
  routeType: RouteType;
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
};

const clickEvent = ({ clickParams, routeType, commonData, localization, curiosityParams }: ClickEvent): void => {
  const { brand, country } = localization;
  const { isApp } = commonData;
  const platform = isApp ? PlatformEnum.APP : PlatformEnum.TSX;
  const analytics = new Analytics({
    market: getMarket(country),
    platform,
    brand,
    AbortController,
    commonData,
    curiosityParams,
    localization,
  });
  clickParams.event_target = getTarget();
  clickParams.event_context = clickParams.event_context ? clickParams.event_context : getContext(routeType);

  try {
    analytics.sendClickEvent({ clickParams });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};

export default clickEvent;
